export default function Canvas_Coordinates() {
  return (
    <div>
      <h1>Canvas_Coordinates Component</h1>
    </div>
  );
}
